<template>
  <div class="user-center-container">
    <el-card class="user-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>个人中心</span>
      </div>
      <div class="user-info">
        <h3>个人信息</h3>
        <el-divider />
        <el-form :model="userInfo" label-width="100px">
          <el-form-item label="用户名">
            <el-input v-model="userInfo.username" readonly></el-input>
          </el-form-item>
          <el-form-item label="昵称">
            <el-input v-model="userInfo.nickname"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="userInfo.email"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="userInfo.phone"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveUserInfo">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-divider />
      <div class="password-section">
        <h3>修改密码</h3>
        <el-divider />
        <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
          <el-form-item label="原密码" prop="oldPassword">
            <el-input
              v-model="passwordForm.oldPassword"
              type="password"
              placeholder="请输入原密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model="passwordForm.newPassword"
              type="password"
              placeholder="请输入新密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              v-model="passwordForm.confirmPassword"
              type="password"
              placeholder="请再次输入新密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="changePassword">修改密码</el-button>
            <el-button @click="resetPasswordForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-divider />
      <div class="user-stats">
        <h3>我的战绩</h3>
        <el-divider />
        <div class="stats-content">
          <h4>战绩功能开发中...</h4>
          <p>敬请期待！</p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'UserCenter',
  data() {
    return {
      userInfo: {
        id: null,
        username: '',
        nickname: '',
        email: '',
        phone: ''
      },
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ]
      }
    }
  },
  created() {
    this.loadUserInfo()
  },
  methods: {
    loadUserInfo() {
      // 从localStorage获取当前登录用户信息
      const userStr = localStorage.getItem('user')
      if (userStr) {
        try {
          const user = JSON.parse(userStr)
          this.userInfo = {
            id: user.id,
            username: user.username,
            nickname: user.nickname || '',
            email: user.email || '',
            phone: user.phone || ''
          }
        } catch (e) {
          console.error('Parse user info error:', e)
          this.$message.error('获取用户信息失败')
        }
      } else {
        // 如果没有登录信息，跳转到登录页
        this.$message.warning('请先登录')
        this.$router.push('/login')
      }
    },
    saveUserInfo() {
      // 验证必填字段
      if (!this.userInfo.nickname) {
        this.$message.warning('请输入昵称')
        return
      }
      
      // 调用API保存用户信息
      this.$axios.put(`/user/update/${this.userInfo.id}`, this.userInfo)
        .then(res => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            // 更新localStorage中的用户信息
            localStorage.setItem('user', JSON.stringify(res.data))
          } else {
            this.$message.error(res.message || '保存失败')
          }
        })
        .catch(error => {
          console.error('Save user info error:', error)
          this.$message.error('保存失败，请重试')
        })
    },
    changePassword() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          // 调用API修改密码
          this.$axios.post('/user/change-password', {
            userId: this.userInfo.id,
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          })
            .then(res => {
              if (res.code === 200) {
                this.$message.success('密码修改成功，请重新登录')
                // 清空表单
                this.resetPasswordForm()
                // 延迟2秒后退出登录
                setTimeout(() => {
                  this.$store.dispatch('logout')
                  this.$router.push('/login')
                }, 2000)
              } else {
                this.$message.error(res.message || '修改失败')
              }
            })
            .catch(error => {
              console.error('Change password error:', error)
              this.$message.error('修改失败，请重试')
            })
        }
      })
    },
    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.clearValidate()
      }
    }
  }
}
</script>

<style scoped>
.user-center-container {
  padding: 20px 0;
}

.user-card {
  margin-bottom: 20px;
}

.user-info {
  margin-bottom: 20px;
}

.password-section {
  margin-bottom: 20px;
}

.user-stats {
  margin-top: 20px;
}

.stats-content {
  text-align: center;
  padding: 20px 0;
}
</style>